
import React, { Fragment } from 'react'
import {AppRow,AppInput} from 'qcc'
import {DemoApiTable} from './DemoApiTable'
import { Row } from 'antd';

const apiData = [
    {attrName:'dataType',type:"'string' | 'number'",defaultValue:'string',remarks:'确定数据类型'},
    {attrName:'readonly',type:'boolean',defaultValue:'false',remarks:'是否允许录入'},
    {attrName:'value',type:'string',defaultValue:'',remarks:''},
    {attrName:'format',type:'string',defaultValue:'#,###.00',remarks:'若dataType为number时有效，格式为#,###.00'},
    {attrName:'state',type:"'default'|'error'|'active'|'readonly'",defaultValue:'default',remarks:'根据状态来确定输入框的默认样式'},
    {attrName:'prefix',type:'string',defaultValue:'',remarks:'输入框的前缀'},
    {attrName:'unit',type:'string',defaultValue:'',remarks:'输入框的显示到后面的单位'},
    {attrName:'placeholder',type:'string',defaultValue:'',remarks:'placeholder'},
    {attrName:'forbidChars',type:'string',defaultValue:'',remarks:'不允许录入的特殊字符，比如：.,""'},
    {attrName:'onChange',type:'(value: string | number, text: string) => void',defaultValue:'',remarks:''},
]
export const AppInputDemo = () =>{
    return (<div className='app-demo-content'>
            <h1>使用说明</h1>    
            <div>
                1、输入框，需要用户界面交互时使用。<br/>
                2、引用：import {`{AppInput}`} from 'qcc'<br/>
                3、demo位置：src/demo/components/AppInputDemo.tsx
            </div>

            <h1>DEMO</h1>
            <div className='app-demo-content-demo'>
               
                <Row style={{padding:20}}>
                    <AppRow>
                       <div style={{width:90}}>文本输入框：
                       </div>
                       <div style={{width:300}}>
                        <AppInput placeholder="请输入姓名" />
                       </div>
                       <div style={{width:300}}>
                        <AppInput placeholder="带前缀的输入框" prefix='000.'/>
                       </div>
                    </AppRow>
                </Row>

                <Row style={{padding:20}}>
                    <AppRow>
                       <div style={{width:90}}>数字输入框：
                       </div>
                       <div style={{width:300}}>
                        <AppInput placeholder="请输入面积" dataType='number' />
                       </div>
                       <div style={{width:300}}>
                        <AppInput placeholder="请输入面积,带单位" dataType='number' unit='平方米' />
                       </div>
                    </AppRow>
                </Row>

              
                
                
            </div>
            
            <h1>API</h1>
             <DemoApiTable data={apiData}/>

    </div>)
}


// WEBPACK FOOTER //
// ./src/demo/components/AppInputDemo.tsx